import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

export const CTA = ({ title = "Planning a project?", text = "Tell us about it and we will talk through how we would approach it." }) => (
  <section data-testid="cta-section" className="relative blueprint border-t border-[#262b38]">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-10 py-28 sm:py-40 grid lg:grid-cols-12 gap-10 items-end">
      <Reveal className="lg:col-span-8">
        <Eyebrow>Next step</Eyebrow>
        <h2 className="font-display font-extrabold tracking-tight text-5xl sm:text-7xl lg:text-8xl leading-[0.95] mt-6">
          {title}
        </h2>
        <p className="text-[#a7aebb] text-base md:text-lg mt-6 max-w-xl">{text}</p>
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-4 lg:justify-self-end">
        <Link
          to="/contact"
          data-testid="cta-discuss-project-btn"
          className="group inline-flex items-center gap-4 bg-[#d96b27] hover:bg-[#f07d38] text-[#0c0e12] pl-8 pr-6 py-6 font-mono text-sm uppercase tracking-[0.18em] transition-colors clip-frame-sm"
        >
          Discuss your project
          <span className="w-10 h-10 bg-[#0c0e12] text-[#f4f5f7] flex items-center justify-center transition-transform duration-500 group-hover:rotate-45">
            <ArrowUpRight className="w-5 h-5" />
          </span>
        </Link>
      </Reveal>
    </div>
  </section>
);
